import { forwardRef, useImperativeHandle } from "react";
import Collapse from "@/components/specific/Collapsable";

const CampaignFAQ = forwardRef((props, ref) => {
  const faqItems = [
    {
      key: "1",
      header: "How do I create a new campaign?",
      content: `To create a new campaign:
        1. Navigate to the Campaigns dashboard
        2. Click "Create New Campaign"
        3. Fill in campaign details
        4. Set your campaign goals and timeline
        5. Review and launch your campaign`,
    },
    {
      key: "2",
      header: "How can I track campaign performance?",
      content: `You can track your campaign performance through:
        - Real-time analytics dashboard
        - Engagement metrics
        - Conversion tracking
        - ROI measurements
        - Custom reports`,
    },
    {
      key: "3",
      header: "What are the best practices for campaign optimization?",
      content: `Key optimization strategies include:
        - Regular performance monitoring
        - A/B testing
        - Audience segmentation
        - Content personalization
        - Timing optimization`,
    },
    {
      key: "4",
      header: "How do I manage campaign budgets?",
      content: `Budget management features include:
        - Setting daily/monthly budgets
        - Cost tracking
        - Budget allocation
        - Expense reporting
        - ROI analysis`,
    },
  ];

  useImperativeHandle(ref, () => ({
    handleContactSupport: async () => {
      window.location.href = "mailto:support@example.com";
    },
  }));

  return (
    <div className="mt-10">
      <Collapse items={faqItems} />
    </div>
  );
});

CampaignFAQ.displayName = "CampaignFAQ";

export default CampaignFAQ;
